import React, {PureComponent} from 'react'
import DiscoveryFeedComponent from '../../components/discovery';
import {changeCurrentTrackWithDelay, updateShowTally} from "../../logic/api";
import {database} from "../../logic/firebase";

export default class DiscoveryFeed extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            allTracks: {},
            playedTracks: {},
            isShowTally: false
        }
    }

    componentDidMount() {
        this.getAllTracks();
        this.getPlayedTracks();
        this.updateTally();
    }

    getAllTracks = () => {
        const tracksRef = database().ref('/translation/tracks').orderByChild('order');
        tracksRef.on('value', (snapshot) => {
                const tracks = {};
                snapshot.forEach((item) => {
                    tracks[item.val().track_id] = item.val()
                });
                this.setState({allTracks: tracks})
            }
        )
    };

    updateTally = () =>{
        const showTallyRef = database().ref('/translation/showTally');
        showTallyRef.on('value', (snapshot) =>
            this.setState({isShowTally: snapshot.val()})
        )
    };

    showTally = async () =>{
        const showTallyRef =  database().ref('/translation/showTally');
        await showTallyRef.set(true)
        await updateShowTally();
        setTimeout(this.hideTally, 5000)
    };

    hideTally = async () =>{
        const showTallyRef =  database().ref('/translation/showTally');
        await showTallyRef.set(false)
        await updateShowTally();
    };

    getPlayedTracks = () => {
        const tracksRef = database().ref('/translation/playedTracks');
        tracksRef.on('value', (snapshot) =>
            this.setState({playedTracks: snapshot.val() || {}})
        )
    };

    setCurrentTrack = async (track) => {
        await database().ref('/translation/currentTrack').set(track)
        await changeCurrentTrackWithDelay();
    };

    render() {
        const {currentTrack} = this.props;
        const {allTracks, playedTracks, isShowTally} = this.state;
        let pendingTracks = Object.keys(allTracks)
            .filter(trackUuid => !playedTracks[trackUuid])
            .map(trackUuid => allTracks[trackUuid]);
        if (currentTrack) {
            pendingTracks.sort((a, b) => a.track_id === currentTrack.track_id ? -1 : b.track_id === currentTrack.track_id ? 1 : 0)
        }
        return <DiscoveryFeedComponent
            isShowTally={isShowTally}
            showTally={this.showTally}
            hideTally={this.hideTally}
            setCurrentTrack={this.setCurrentTrack}
            currentTrack={currentTrack}
            pendingTracks={pendingTracks}
            playedTracks={Object.values(playedTracks)}
        />
    }
}